import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import {SvgIconComponent} from '@mui/icons-material';
import {
    PATH_ACTIVE_SINGLE_VOYAGES,
    PATH_HISTORY_SINGLE_VOYAGES,
    PATH_MONITORING_SINGLE_VOYAGES,
    PATH_POINTS_TEMPLATES_SINGLE_VOYAGE,
    PATH_READERS_SINGLE_VOYAGE,
    PATH_REPORTS_SINGLE_VOYAGE,
    PATH_SCHEDULED_SINGLE_VOYAGES,
    PATH_TRACKABLE_OBJECTS_SINGLE_VOYAGE,
    PATH_VIDEO_SINGLE_VOYAGE,
    PATH_VOYAGE_TEMPLATE_PLANNING_SINGLE_VOYAGE,
    PATH_VOYAGE_TEMPLATES_SINGLE_VOYAGE
} from "@constants/navigate";

export const ROOT_NAVIGATE_SINGLE_VOYAGES: {
    path: string,
    label: string,
    icon?: SvgIconComponent
}[] = [
    {
        path: PATH_MONITORING_SINGLE_VOYAGES,
        label: 'singleVoyage.navigate.monitoring'
    },
    {
        path: PATH_SCHEDULED_SINGLE_VOYAGES,
        label: 'singleVoyage.navigate.planned'
    },
    {
        path: PATH_VOYAGE_TEMPLATE_PLANNING_SINGLE_VOYAGE,
        label: 'singleVoyage.navigate.planning'
    },
    {
        path: PATH_ACTIVE_SINGLE_VOYAGES,
        label: 'singleVoyage.navigate.active'
    },
    {
        path: PATH_HISTORY_SINGLE_VOYAGES,
        label: 'singleVoyage.navigate.archive'
    },
    {
        path: PATH_REPORTS_SINGLE_VOYAGE,
        label: 'singleVoyage.navigate.reports'
    },
    {
        path: PATH_POINTS_TEMPLATES_SINGLE_VOYAGE,
        label: 'singleVoyage.navigate.pointTemplates'
    },
    {
        path: PATH_VOYAGE_TEMPLATES_SINGLE_VOYAGE,
        label: 'singleVoyage.navigate.voyageTemplates'
    },
    {
        path: PATH_TRACKABLE_OBJECTS_SINGLE_VOYAGE,
        label: 'singleVoyage.navigate.trackableObjects'
    },
    {
        path: PATH_READERS_SINGLE_VOYAGE,
        label: 'singleVoyage.navigate.readers'
    },
    {
        path: PATH_VIDEO_SINGLE_VOYAGE,
        label: 'singleVoyage.navigate.video',
        icon: VideocamOutlinedIcon
    },
]
